import { Group, Skeleton, Stack, Text } from "@mantine/core";

import { Sparkle } from "../Sparkle";

export interface DynamicCoreBenefitsProps {
    isEnabled?: boolean;
    isAwaitingData?: boolean;
    isPending?: boolean;
    pitchPoints?: string[];
}

export const DynamicCoreBenefits = ({
    isEnabled = false,
    isAwaitingData = false,
    isPending = false,
    pitchPoints,
}: DynamicCoreBenefitsProps) => {
    if (!isEnabled || isAwaitingData) {
        return null;
    }

    if (isPending) {
        return (
            <Group gap="sm" align="center">
                <Sparkle />
                <Skeleton height={12} width={220} />
            </Group>
        );
    }

    if (!pitchPoints?.length) return null;

    return (
        <Stack gap="sm">
            {pitchPoints.map((point, i) => (
                <Group key={i} gap={6} align="flex-start" wrap="nowrap" bg={"dark.5"} p={8} bdrs={"md"}>
                    <Sparkle />
                    <Text c="dark.1" size="xs">
                        {`"${point}"`}
                    </Text>
                </Group>
            ))}
        </Stack>
    );
};
